import { createSlice } from "@reduxjs/toolkit";
import { addonCTRPurchaseAction, addonGetCTRFormAction } from "../../actions";

export interface IAddonFeatures {
    title: string;
    subFeatures: string[];
    _id: string;
}

export interface IAddon {
    _id: string;
    addon_id: string;
    name: string;
    disabled: boolean;
    price: number;
    priceId: string;
    productId: string;
    currency: string;
    category: string;
    features: IAddonFeatures[];
    reseller_cost_cents?: number;
    reseller_product_id?: string;
    __v: number;
    createdAt: string;
    updatedAt: string;
}

export interface IAddonCTRPurchaseData {
    url: string;
    sessionId: string;
    addon: IAddon;
    transaction_id: string;
}

export interface IAddonGetCTRFormData {
    radius: string;
    business_id: string;
    keywords: string[];
    primary_keywords: string[];
    city_keywords: string[];
    branded_keywords: string[];
    longtail_keywords: string[];
    map_pack_daily_conversion: {
        enabled: boolean;
        intensity: string;
    }
    driving_directions: boolean;
    engagement_actions: {
        website: boolean;
        call: boolean;
    }
}

interface IAddonsState {
    addonCTRPurchaseData: IAddonCTRPurchaseData | null
    addonCTRPurchaseDataLoading: boolean
    addonGetCTRFormData: IAddonGetCTRFormData | null
}

const initialState: IAddonsState = {
    addonCTRPurchaseData: null,
    addonCTRPurchaseDataLoading: false,
    addonGetCTRFormData: null
}

const addonSlice = createSlice({
    name: "addon",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            //addon ctr purchase
            .addCase(addonCTRPurchaseAction.pending, (state) => {
                state.addonCTRPurchaseDataLoading = true
                state.addonCTRPurchaseData = null
            })
            .addCase(addonCTRPurchaseAction.fulfilled, (state, action) => {
                state.addonCTRPurchaseDataLoading = false
                state.addonCTRPurchaseData = action.payload.data
            })
            .addCase(addonCTRPurchaseAction.rejected, (state, action) => {
                state.addonCTRPurchaseDataLoading = true
                state.addonCTRPurchaseData = null
            })

            //addon grt ctr form
            .addCase(addonGetCTRFormAction.pending, (state) => {
                state.addonGetCTRFormData = null
            })
            .addCase(addonGetCTRFormAction.fulfilled, (state, action) => {
                state.addonGetCTRFormData = action.payload.data
            })
            .addCase(addonGetCTRFormAction.rejected, (state, action) => {
                state.addonGetCTRFormData = null
            })
    }
})

export default addonSlice.reducer